import { Tooltip } from "flowbite-react";
import { useEffect, useState } from "react";
import { Popup } from "../../../components/pop-up";
import { IconButton } from "../../../components/buttons";
import { TextBox } from "../../../components/inputs";

export function ToggleCustomerStatus(props) {
  const [openModal, setOpenModal] = useState();
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  useEffect(()=>{
    setError("");
    setReason("")
  },[openModal])
  return (
    <>
      <Tooltip
        content={
          props?.data?.is_active ? "Deactivate customer" : "Activate customer"
        }
        placement="bottom"
      >
        <IconButton
          type="button"
          size="sm"
          onClick={() => setOpenModal("pop-up")}
          // class="rounded-xl bg-indigo-100 p-2 text-indigo-600 hover:bg-indigo-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {props.data?.is_active ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          )}
        </IconButton>
      </Tooltip>
      <Popup
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`${
                props?.data?.is_active ? "stroke-red-600" : "stroke-green-500"
              } mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to{" "}
              {props?.data?.is_active ? "deactivate" : "activate"}{" "}
              <b
                className={
                  props?.data?.is_active ? "text-red-500" : "text-green-500"
                }
              >
                {props?.data?.company_name}
              </b>
              ?
              <TextBox
                className="text-left"
                placeholder="Please enter a reason"
                required
                value={reason}
                onChange={(e) => {
                  let value = e.target.value
                  setError(!value?"Reason is required":"");
                  setReason(value);
                }}
                error={error}
              />
            </h3>
          </>
        }
        cancelText="No, cancel"
        confirmText={`Yes, ${
          props?.data?.is_active ? "deactivate" : "activate"
        }`}
        confirmClass={
          props?.data?.is_active
            ? "bg-red-600 text-white"
            : "bg-green-500 text-white"
        }
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          if (!reason) {
            setError("Reason is required");
          } else {
            props.onConfirm && props.onConfirm({ ...props.data, reason });
            setOpenModal(undefined);
          }
        }}
      />
    </>
  );
}
